import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const FullScreen = ({setSelected}:{setSelected:any}) => {

    const [searchParams, setSearchParams] = useSearchParams();


    const getDeviceType = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);

        return (isMobile ? "mobile" : "desktop");
    }
    const handleKeyDownExitFullScreen = () => {
        if (!document.fullscreenElement) {
            setSelected((prevState: any)=>{
                return prevState.filter((item: any)=> item !== 'fullscreen');
            });
        }
    };
    
    const openDesktopFullscreen = () => {
        if (!document.fullscreenElement) {
            const docElm: any = document.documentElement;
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            } else if (docElm.mozRequestFullScreen) { /* Firefox */
                docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                docElm.webkitRequestFullscreen();
            } else if (docElm.msRequestFullscreen) { /* IE/Edge */
                docElm.msRequestFullscreen();
            }
        }
        window.addEventListener('fullscreenchange', ()=>handleKeyDownExitFullScreen());

    }
    
    const closeDesktopFullscreen = async () => {
        if (document.fullscreenElement) {
            if (document.exitFullscreen) {
                await document.exitFullscreen();
            } else if ((document as any).mozCancelFullScreen) { /* Firefox */
                (document as any).mozCancelFullScreen();
            } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
                (document as any).webkitExitFullscreen();
            } else if ((document as any).msExitFullscreen) { /* IE/Edge */
                (document as any).msExitFullscreen();
            }
        }
        window.removeEventListener('fullscreenchange', ()=>handleKeyDownExitFullScreen());
    }
    
    const openMobileFullscreen = () => {
        
        searchParams.append('fullscreenMode', '1');

        const url = new URL(window.location.href);
        url.search = searchParams.toString();
        window.open(url, '_blank');
        
        setSelected((prevState: any)=>{
            return prevState.filter((item: any)=> item !== 'fullscreen');
        });
        
    }

    useEffect(() => {
        const deviceType = getDeviceType();
        if(deviceType === 'mobile'){
            openMobileFullscreen();
        }
        if (deviceType === 'desktop'){
            openDesktopFullscreen();  
        }
        
        return () => {
            const deviceType = getDeviceType();
            if (deviceType === 'desktop'){
                closeDesktopFullscreen();
            }
        };

    },[]);
    
    return <></>
}
